<ng-lottie [options]="lottieOptions"></ng-lottie>

<section>
  As You can probably see not much is aroud here... <br />
  The lack of functionality is coused by the lack of project manager<br />
  The lack of UI/UX is because I'm not a Designer<br />
  But the <a routerLink="code">code</a> is mine
</section>
